import * as React from 'react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { InterviewData } from '@/lib/interviewTypes';

interface InterviewCardStudentSectionProps {
    interview: InterviewData;
    isMissed: boolean;
    hasAgreed: boolean;
    isAgreeing: boolean;
    onAgree: () => Promise<void>;
}

const InterviewCardStudentSection: React.FC<InterviewCardStudentSectionProps> = ({
    interview,
    isMissed,
    hasAgreed,
    isAgreeing,
    onAgree,
}) => {
    const handleAgree = async () => {
        try {
            await onAgree();
        } catch (error: any) {
            console.error('Error agreeing to interview', error);
            toast.error(error?.data?.message || error?.message || 'Failed to agree to interview');
        }
    };

    if (interview.status === 'completed') {
        return (
            <div className="rounded-md border border-emerald-100 bg-emerald-50/70 px-4 py-3 text-sm text-gray-700">
                <p>
                    <strong className="text-emerald-700">Score:</strong>{' '}
                    <span className="font-semibold text-emerald-600">
                        {interview.overallScore}% ({Math.round((interview.overallScore || 0) / 10)}/10)
                    </span>
                </p>
                {(interview.technicalScore || interview.communicationScore || interview.problemSolvingScore) ? (
                    <p className="mt-1 text-gray-600">
                        <strong>Technical:</strong> {interview.technicalScore ?? 'N/A'}% |{' '}
                        <strong>Communication:</strong> {interview.communicationScore ?? 'N/A'}% |{' '}
                        <strong>Problem Solving:</strong> {interview.problemSolvingScore ?? 'N/A'}%
                    </p>
                ) : null}
                {interview.feedback ? (
                    <p className="mt-2 text-gray-600">
                        <strong>Feedback:</strong> {interview.feedback}
                    </p>
                ) : null}
            </div>
        );
    }

    if (interview.status === 'scheduled') {
        return (
            <div className="space-y-3">
                {isMissed ? (
                    <p className="text-sm font-medium text-red-600">
                        You missed this interview. The scheduled time has already passed.
                    </p>
                ) : (
                    <Button
                            className="bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-600 dark:hover:bg-emerald-700 dark:text-gray-100 hover:b"
                        onClick={handleAgree}
                        disabled={isAgreeing || hasAgreed}
                    >
                        {hasAgreed ? 'Agreed' : (isAgreeing ? 'Processing...' : 'I Agree to Attend')}
                    </Button>
                )}
            </div>
        );
    }

    return null;
};

export default InterviewCardStudentSection;
